import { InputBase, useTheme } from "@mui/material";
import type { FC, KeyboardEvent, RefObject } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	inputRef: RefObject<HTMLInputElement | null>;
	value: string;
	onChange: (value: string) => void;
	onSubmit: () => void;
};

export const ChatComposerInput: FC<Props> = ({
	inputRef,
	value,
	onChange,
	onSubmit,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "Enter" && !event.shiftKey) {
			event.preventDefault();
			onSubmit();
		}
	};

	return (
		<InputBase
			inputRef={inputRef}
			value={value}
			onChange={(event) => onChange(event.target.value)}
			onKeyDown={handleKeyDown}
			placeholder={t(Resources.Chat.inputPlaceholder)}
			sx={{
				flex: 1,
				minWidth: 0,
				px: 1.2,
				py: 0.8,
				fontSize: 14,
				bgcolor: theme.palette.grey[100],
				borderRadius: theme.shape.pillRadius,
				"& input": { p: 0 },
				"& input::placeholder": {
					color: theme.palette.grey[400],
					opacity: 1,
				},
			}}
		/>
	);
};
